import {http, longHttp} from './index';
import {ReqMessageListApi, ReqNewMessageApi} from '@types';

//阅读消息
export const readNewMessage = (id: number) => http.put(`/teaching-workbench/qa/user/message/read/${id}`);

//新消息（长轮询）
export const getNewMessage = (params: ReqNewMessageApi, options?: {}) => longHttp.get('/teaching-workbench/qa/user/message/new', params, options);

//消息历史
export const getMessageList = (params: ReqMessageListApi) => http.get('/teaching-workbench/qa/user/message/page', params);

//未读消息统计信息
export const getUnreadList = () => http.get('/teaching-workbench/qa/user/message/statistics');

//查询私教相关的七种消息
export const getPersonalServiceMessageType = (params: { userId: number }) => http.get('/teaching-workbench/qa/user/message/statistics/pt', params);

//验证查看详情/进入教室的可行性
export const getEntry = (params: { processId: number, buttonType: number, messageType: string }) => http.get('/teaching-workbench/qa/user/message/toast', params);